import React, { Component } from 'react';
import cn from 'classnames';
import css from './css.css';
// import { Col } from 'react-flexbox-grid';
import { Col } from '~/native-ui';

export default class StyledCol extends Component {
	static propTypes = {
	
	};

    levelOuterClassName = () => {
        let { rowTheme } = this.props;
        return rowTheme ? cn(css[`level${rowTheme}Outer`], css.levelOuter) : null;
    };

    levelClassName = () => {
        let { rowTheme } = this.props;
        return rowTheme ? cn(css[`level${rowTheme}`], css.level) : null;
    };

    wrapLevelled = (rendered) => {
        let  { rowTheme, xs, md, lg,  sm, gap, colCount  } = this.props;

        const props = {
            xs, md, lg,  sm,
            shadow: rowTheme, colCount, gap
        };

        return (
            <Col { ...props }>
                {rendered}
            </Col>
        );
    };


    render() {
	    let { className, children, rowTheme, style, ...props } = this.props;

		return (
            // <div {...props} style={[ props.style ]}>
                // {this.wrapLevelled(children)}
                this.wrapLevelled(children)
            // </div>
		);
	}
}